import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Home from "./pages/home";
import About from "./pages/about";
import NotFound from "./pages/not_found";
import Navbar from "./components/Global/navbar";
import Footer from "./components/Global/footer";
import Works from "./pages/how-it-works";
import LoanProducts from "./pages/loan-products";
import DSA from "./pages/for-dsas";
import Lenders from "./pages/for-lenders";
import Contact from "./pages/contact";
import PrivacyPolicy from "./pages/privacy-policy";
import Terms from "./pages/terms";
import ScrollToTop from "./components/Global/scroll-to-top";
import { LoanModalProvider } from "./context/loan-modal-context";
import { CalculatorModalProvider } from "./context/calculator-modal-context";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <BrowserRouter>
      <LoanModalProvider>
        <CalculatorModalProvider>
          <ToastContainer position="top-right" autoClose={3500} theme="colored" />
          <ScrollToTop />
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/how-it-works" element={<Works />} />
            <Route path="/loan-products" element={<LoanProducts />} />
            <Route path="/for-dsas" element={<DSA />} />
            <Route path="/for-lenders" element={<Lenders />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-and-condition" element={<Terms />} />
             
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Footer />
        </CalculatorModalProvider>
      </LoanModalProvider>
    </BrowserRouter>
  );
}

export default App;